import React, { FunctionComponent, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { closeConfirmNotificationAction } from '../..';
import { OrbModalConfirm } from '../../../../../components/orb-modal-confirm';
import { i18n } from '../../../../../helpers/i18n';
import { getNotificationContentText, getNotificationHeaderText } from '../../selectors';

export const ConfirmNotification: FunctionComponent = () => {
    const dispatch = useDispatch();

    const headerText = useSelector(getNotificationHeaderText);
    const contentText = useSelector(getNotificationContentText);

    const handleClose = useCallback(() => {
        dispatch(closeConfirmNotificationAction());
    }, [dispatch]);

    if (!headerText || !contentText) {
        return null;
    }

    return (
        <OrbModalConfirm
            titleLineLimit={2}
            title={headerText}
            onClose={handleClose}
            onConfirm={handleClose}
            confirmLabel={i18n('common', 'got-it')}
        >
            {contentText}
        </OrbModalConfirm>
    );
};
